import type { PlantManagerAsset, PlantManagerComponent } from '@e2grnd/ui-core/dist/types'
import type { ReactNode } from 'react'

import examples from './examples'
import params from './params'

export { examples, params }

export const assetComponentParamsMapFn = (pmAsset: PlantManagerAsset, pmComponent: PlantManagerComponent) => {
  if(!pmAsset) {
    return { fieldValues: {} }
  }

  console.log('Mapping asset data:\n\tAsset:', pmAsset, '\n\tComponent:', pmComponent)
  const warnings: ReactNode[] = []
  const errors: ReactNode[] = []

  let innerDiameter
  if(!pmComponent.innerDiameter) {
    warnings.push('The selected component does not have an inner diameter defined. Thus, we calculate the inner diameter from the outer diameter and the nominal thickness.')
    if(!pmComponent.outerDiameter) {
      warnings.push('The selected component does not have an outer diameter defined.')
    } else {
      if(!pmComponent.nominalThickness) {
        warnings.push('The selected component does not have a nominal thickness defined.')
      } else {
        innerDiameter = pmComponent.outerDiameter - 2.0 * pmComponent.nominalThickness
      }
    }
  } else {
    innerDiameter = pmComponent.innerDiameter
  }

  let nominalThickness
  if(!pmComponent.nominalThickness) {
    warnings.push('The selected component does not have a nominal thickness defined.')
  } else {
    nominalThickness = pmComponent.nominalThickness
  }

  let temperature
  if(!pmComponent.circuit) {
    warnings.push('The selected component does not have a circuit defined.')
    if(!pmComponent.designTemperature) {
      warnings.push('The selected component does not have a design temperature defined.')
    }
    temperature = pmComponent.designTemperature
  } else {
    if(!pmComponent.circuit.operatingTemperature) {
      warnings.push('The selected component does not have a circuit operating temperature defined.')
    }
    temperature = pmComponent.circuit.operatingTemperature
  }

  let pressure
  if(!pmComponent.circuit) {
    warnings.push('The selected component does not have a circuit defined.')
    if(!pmComponent.designPressure) {
      warnings.push('The selected component does not have a design pressure defined.')
    }
    pressure = pmComponent.designPressure
  } else {
    if(!pmComponent.circuit.operatingPressure) {
      warnings.push('The selected component does not have a circuit operating pressure defined.')
    }
    pressure = pmComponent.circuit.operatingPressure
  }

  let minimumThickness
  if(!pmComponent.minimumThickness) {
    warnings.push('The selected component does not have a minimum thickness defined.')
  } else {
    minimumThickness = pmComponent.minimumThickness
  }

  let inServiceDate
  if(!pmComponent.inServiceDate) {
    warnings.push('The selected component does not have a minimum thickness defined.')
  } else {
    const inServiceDateTemp = pmComponent.inServiceDate
    const dateArray = inServiceDateTemp.split("-")
    inServiceDate = dateArray[1].concat('/',dateArray[2],'/',dateArray[0])
  }

  return {
    errors,
    warnings,
    fieldValues: {
      innerDiameter,
      componentThickness: nominalThickness,
      temperatureAmmoniumChlorideCorrosionDM: temperature,
      temperatureSulidationDM: temperature,
      failureThickness: minimumThickness,
      timeSinceInstall: inServiceDate,
      gasStreamTotalPressure: pressure
    },
  }
}
